import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogIn } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useClickOutside } from '../hooks/useClickOutside';
import { UserAvatarButton, UserMenuDropdown } from './user/UserMenuParts';

export const UserMenu = () => {
  const { user, loading, login, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();
  useClickOutside(ref, () => setOpen(false));

  if (loading) return null;

  if (!user) {
    return (
      <button type="button" data-testid="nav-signin-button" onClick={login} className="flex items-center space-x-2 bg-gradient-to-r from-gold-400 to-gold-500 hover:from-gold-300 hover:to-gold-400 text-[#143160] font-bold rounded-full px-4 py-2 text-sm transition-all hover:scale-105 shadow-lg">
        <LogIn className="w-4 h-4" />
        <span className="whitespace-nowrap">Sign In</span>
      </button>
    );
  }

  const go = (path) => { setOpen(false); navigate(path); };
  const signOut = () => { setOpen(false); logout(); navigate('/'); };

  return (
    <div className="relative" ref={ref}>
      <UserAvatarButton user={user} onClick={() => setOpen((v) => !v)} />
      {open && <UserMenuDropdown user={user} onNavigate={go} onLogout={signOut} />}
    </div>
  );
};
